import { useState } from "react";
import axios from "axios";

const useImageGeneration = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const generateImage = async (prompt) => {
    if (!prompt?.trim()) {
      setError("Необходимо заполнить название или описание изображения");
      return null;
    }

    const apiKey = import.meta.env.VITE_STABILITY_API_KEY;
    if (!apiKey) {
      setError("API ключ не настроен");
      console.error("Missing VITE_STABILITY_API_KEY in environment variables");
      return null;
    }

    setLoading(true);
    setError("");

    try {
      // Используем новый эндпоинт Stability AI v2beta с multipart/form-data
      const formData = new FormData();
      formData.append("prompt", prompt);
      formData.append("output_format", "png");
      formData.append("none", ""); // Требуется пустое поле для multipart

      const response = await axios.post(
        `${import.meta.env.VITE_API_HOST ?? "https://api.stability.ai"}/v2beta/stable-image/generate/ultra`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${apiKey}`,
            Accept: "image/*",
          },
          responseType: "arraybuffer", // Получаем изображение как binary data
        }
      );

      if (response.status !== 200) {
        throw new Error(`Ошибка ${response.status}: ${response.statusText}`);
      }

      // Конвертируем arraybuffer в base64
      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );

      return `data:image/png;base64,${base64}`;
    } catch (err) {
      const errorMessage = err.response?.data
        ? new TextDecoder().decode(err.response.data)
        : err.message;
      setError(errorMessage || "Произошла ошибка при генерации изображения");
      console.error("Image generation error:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    generateImage,
  };
};

export default useImageGeneration;
